import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CallBackControllerService } from './api/callBackController.service';
import { CallControllerService } from './api/callController.service';
import { ClinicControllerService } from './api/clinicController.service';
import { HealthControllerService } from './api/healthController.service';
import { HotlineControllerService } from './api/hotlineController.service';
import { MemberControllerService } from './api/memberController.service';
import { NotificationControllerService } from './api/notificationController.service';
import { SecurityControllerService } from './api/securityController.service';
import { UserControllerService } from './api/userController.service';
import { WebsocketControllerService } from './api/websocketController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    CallBackControllerService,
    CallControllerService,
    ClinicControllerService,
    HealthControllerService,
    HotlineControllerService,
    MemberControllerService,
    NotificationControllerService,
    SecurityControllerService,
    UserControllerService,
    WebsocketControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
